import { useSpring, a } from '@react-spring/three';
import { useFrame } from '@react-three/fiber';
import { useRef, useState } from 'react';
import CaseModel from './CaseModel';

export const FallingCase = ({ textureUrl, playLid }: { textureUrl: string, playLid: boolean }) => {
  const ref = useRef<any>(null);
  const [falling, setFalling] = useState(true);

  // Контролируем активность покачивания через реф
  const wobbleActiveRef = useRef(false);
  const wobbleStartTime = useRef<number | null>(null);

  // Падение
  const { position, rotation } = useSpring({
    from: { position: [0, 2, 0], rotation: [0, 0, 0] },
    to: async (next) => {
      await next({ position: [0, 0, 0] });
      setFalling(false);
      wobbleActiveRef.current = true; // включаем покачивание
      wobbleStartTime.current = null; // сброс времени
    },
    config: { mass: 1, tension: 120, friction: 14 },
  });

  useFrame(({ clock }) => {
    if (wobbleActiveRef.current && ref.current) {
      if (!wobbleStartTime.current) wobbleStartTime.current = clock.elapsedTime;
      const elapsed = clock.elapsedTime - wobbleStartTime.current;
    }
  });

  return (
    <a.group ref={ref} position={position as any} rotation={rotation as any}>
      <CaseModel textureUrl={textureUrl} playLid={playLid} />
    </a.group>
  );
};
